import React from 'react';
import './Team.css';

const traits = [
  { icon: '♟', label: 'Настолки' },
  { icon: '🎮', label: 'Игры' },
  { icon: '💬', label: 'Открытые споры' },
  { icon: '🍕', label: 'Неформальные встречи' },
];

export default function Team() {
  return (
    <section className="section" id="team">
      <div className="container">
        <div className="team__inner">
          <div className="team__left reveal">
            <div className="section-label">// 003 · команда</div>
            <h2 className="section-title">
              Четыре человека.<br />
              <span className="green">Одно направление.</span>
            </h2>
            <p style={{ color: 'var(--text-muted)', lineHeight: '1.9' }}>
              Мы ищем не просто исполнителей — нам важно человеческое
              совпадение. Хотим, чтобы команда была живой: обсуждали идеи,
              спорили, придумывали, и иногда встречались за настолками.
            </p>

            <div className="team__traits">
              {traits.map((t) => (
                <div key={t.label} className="team__trait">
                  <span className="team__trait-icon">{t.icon}</span>
                  <span>{t.label}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="team__right reveal">
            <div className="team__visual">
              <div className="team__nodes">
                {['', '', '', ''].map((_, i) => (
                  <div
                    key={i}
                    className={`team__node team__node--${i}`}
                    style={{ animationDelay: `${i * 0.4}s` }}
                  >
                    <span>{i + 1}</span>
                  </div>
                ))}
                <div className="team__center">
                  <img src="/logo.png" alt="" />
                </div>
              </div>
              <p className="team__visual-label">
                Удалённая команда · Живое общение
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
